import { Observable } from "rxjs"
import { ref, provide } from "vue"

export function useSearchBar() {
    const showSearch = ref(false)
    const hideControls = ref(false)
    const searchTerm = ref("")

    const searchBarMethods = {
        requestShow: () => {
            hideControls.value = true

            setTimeout(() => {
                showSearch.value = true
            }, 200);
        },
        requestHide: () => {
            showSearch.value = false
            setTimeout(() => {
                hideControls.value = false
            }, 100);
        }
    }

    provide("SearchBarService", {
        isActive: showSearch,
        hideControls,
        searchTerm,
        searchBarMethods
    })

    return {
        searchTerm,
        hideControls,
        searchBarMethods,
    }
}

export default function useSearchStore() {

    const observeList = ref([])

    const on = function (name) {
        return new Observable((subscriber) => {
            observeList.value.push({
                name,
                subscriber
            })
        })
    }

    const emit = function (name, data = null) {
        let events = observeList.value.filter(x => x.name == name)
        for (const sub of events) {
            sub.subscriber.next({
                name,
                data
            })
        }
    }

    provide('SearchStore', {
        on,
        emit
    })

    return {
        on,
        emit
    }
}
